import { render } from "./Button.vue?vue&type=template&id=39a6e920&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=39a6e920&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39a6e920"

export default script